import React from 'react'
import Amplify from 'aws-amplify'
import { AmplifyAuthContainer, AmplifyAuthenticator, AmplifySignUp, AmplifySignIn, AmplifySignOut } from '@aws-amplify/ui-react';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';

import { I18n } from 'aws-amplify';
import { Translations } from "@aws-amplify/ui-components";
import ja from "@aws-amplify-jp/vocabulary-ja";
import wdd2021logo from './wdd2021entry.jpg';
import wagbylogo from './wagbytrial_top.jpg';
// import logo from './logo.svg';
import './App.css';

const passwordpolicymsg = ' (8文字以上の大文字、小文字、数字、特殊文字を含む英数字)';

const jaTranslations = ja(Translations);
// jaTranslations[Translations.SIGN_IN_HEADER_TEXT] = "Wagby WDD2021 サインイン"
jaTranslations['Email cannot be empty'] = 'メールアドレスは必須です'
jaTranslations['Password did not conform with policy: Password not long enough'] = 'パスワードは8文字以上を入力してください' + passwordpolicymsg
jaTranslations['Password did not conform with policy: Password must have uppercase characters'] = 'パスワードには大文字を含めてください' + passwordpolicymsg
jaTranslations['Password did not conform with policy: Password must have lowercase characters'] = 'パスワードには小文字を含めてください' + passwordpolicymsg
jaTranslations['Password did not conform with policy: Password must have numeric characters'] = 'パスワードには数字を含めてください' + passwordpolicymsg
jaTranslations['Password did not conform with policy: Password must have symbol characters'] = 'パスワードには特殊文字を含めてください' + passwordpolicymsg
I18n.putVocabulariesForLanguage("ja-JP", jaTranslations);
I18n.setLanguage('ja-JP');
Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    region: "ap-northeast-1",
    identityPoolRegion: "ap-northeast-1",
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  }
});

const WagbyHeader = () => {
  return (process.env.REACT_APP_USER_BRANCH === "wdd2021account") ? (
    <div className="WagbyLogo">
      <img className="WagbyLogoImg" alt="Wagby Developper Day 2021 entry" src={wdd2021logo}/>
    </div>
  ) : (
    <div className="WagbyLogo">
      <img className="WagbyLogoImg" alt="Wagby trial entry" src={wagbylogo}/>
    </div>
  )
}

const WagbyFooter = () => {
  return (
    <div align="center">(C) 2021 <a target="_blank" rel="noreferrer" href="http://www.jasminesoft.co.jp">JasmineSoft</a> Co.,Ltd.</div>
  )
}

const App = () => {
  // window.location.href = "http://localhost:8921/wagby/";
  return (
    <div className="App">
      <WagbyHeader/>
      <div>ログインに成功しました。</div> 
      <div><a target="_blank" rel="noreferrer" href="https://wagby.com/event/wdd2021/">Wagby Developper Day 2021</a></div> 
      <div><a target="_blank" rel="noreferrer" href="https://trial.dev.wagby.com">Wagbyトライアル</a></div> 
      <AmplifySignOut />
      <WagbyFooter/>
    </div>
  )
}

const AuthStateApp = () => {
  const [authState, setAuthState] = React.useState();
  const [user, setUser] = React.useState();

  React.useEffect(() => {
      return onAuthUIStateChange((nextAuthState, authData) => {
          setAuthState(nextAuthState);
          setUser(authData)
      });
  }, []);
  
  return authState === AuthState.SignedIn && user ? (
    <App/>
  ) : authState === AuthState.ConfirmSignUp ? (
    <div className="App">
      <WagbyHeader/>
      <div>入力いただいたメールアドレスにメールをお送りいたしました。ご確認のうえ、メール文中の「Verify Email」のリンクをクリックしてください。</div> 
      <WagbyFooter/>
    </div>
  ) : (
    <AmplifyAuthContainer>
      <WagbyHeader/>
      <AmplifyAuthenticator usernameAlias="email" initialAuthState="signup">
        <AmplifySignUp slot="sign-up" usernameAlias="email"
          formFields={[
            { type: "email" },
            {
              type: "password",
              label: "パスワード *" + passwordpolicymsg,
              placeholder: "パスワードを入力",
              inputProps: { required: true, autocomplete: "new-password" },
            }
          ]}
        >
        <div slot="header-subtitle">
        {
          (process.env.REACT_APP_USER_BRANCH === "wdd2021account") ? (
            <div align="left">
            <a target="_blank" rel="noreferrer" href="https://wagby.com/event/wdd2021/">Wagby Developer Day 2021</a>の視聴には、Wagbyのアカウント登録が必要です。<br/>
            必要事項を入力の上、「アカウントを作成」ボタンをクリックして進めてください。
            </div>
          ): (
            <div align="left">
            Wagbyのトライアル利用には、Wagbyのアカウント登録が必要です。<br/>
            必要事項を入力の上、「アカウントを作成」ボタンをクリックして進めてください。
            </div>
          )
        }
        </div>
        {
          (process.env.REACT_APP_USER_BRANCH === "wdd2021account") ? (
            <div slot="secondary-footer-content"></div>
          ) : (process.env.REACT_APP_USER_BRANCH === "prod") ? (
            <div slot="secondary-footer-content"></div>
          ) : (
            <div/>
          )
        }
        </AmplifySignUp>
        <AmplifySignIn slot="sign-in" usernameAlias="email" >
        {/* <div slot="header-subtitle">
          <div align="center"><img src={wagbylogo}/> Wagbyアカウント</div>
        </div>*/}
        </AmplifySignIn>
      </AmplifyAuthenticator>
      <WagbyFooter/>
    </AmplifyAuthContainer>
  );
}

export default AuthStateApp
